import { useSendCommand } from '@/_core/cqrs/use';
import { RealTimeAction } from '@/_core/fluxstore/types';
import { DeleteStatus as DeleteStatusCommand } from '../../../api/commands';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class DeleteStatus extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'DeleteStatus';

    public constructor(public key: number, public otherStatusToMoveTo: number) {
        super(DeleteStatus.ACTION_TYPE);
    }
}

const middleware = (state: StorymapState, action: DeleteStatus): Promise<boolean> => {
    return useSendCommand(action, {
        createCommand: () => new DeleteStatusCommand(state.id, action.key, action.otherStatusToMoveTo != null, action.otherStatusToMoveTo),
    });
};

const reducer = (state: StorymapState, action: DeleteStatus): void => {
    const cardsInStatus = state.subtasks.filter(x => x.status == action.key);
    cardsInStatus.forEach(x => x.status = action.otherStatusToMoveTo);

    const status = state.subtaskStatuses.find(x => x.key == action.key);
    const otherStatusesInCategory = state.subtaskStatuses.filter(x => x.category == status.category && x.order > status.order);
    otherStatusesInCategory.forEach(x => x.order--);

    state.subtaskStatuses = state.subtaskStatuses.filter(x => x.key != action.key);
};

//@ts-ignore
registerMiddleware(DeleteStatus.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(DeleteStatus.ACTION_TYPE, reducer);
